module.exports = __webpack_public_path__ + "static/bvideomock-29b717686290a16ff9f4a9b87df836b2.mp4";